/**
 * Анимация статистики на детальной матча
 */
$.fn.videoGallery = function() {
    const $self = $(this);
    const $slides = $self.find('.js-gallery-item');
    const $popup = $('.js-popup-video-gallery');
    const $counter = $popup.find('.js-popup-item-count');
    const $frames = $popup.find('.js-frame-holder');
    let $nextButton = $popup.find('.js-popup-next');
    let $prevButton = $popup.find('.js-popup-prev');
    let slideIndex = 0;
    let $currentVideo;

    /**
     * Счетчик в попапе
     * @param {Number} currentIndex
     */
    const setSlidesCounter = (currentIndex) => {
        $counter.text(`${currentIndex + 1}/${$slides.length}`);
    };

    /**
     * Открытие попапа
     */
    const openPopup = (currentIndex) => {
        slideIndex = currentIndex;
        setSlidesCounter(slideIndex);
        $('html').addClass('fixed');
        $.magnificPopup.open({
            items: {
                src: $popup,
                type: 'inline'
            },
            mainClass: 'popup--gallery',
            showCloseBtn: false
        });
        setDisabledButtonInPopup();
        setSizeFrame();
        toggleLoader(true);
    };

    const showVideo = (id) => {
        $frames.hide();
        const videoId = '#video-' + id;
        $frames.filter(videoId).show();
        $currentVideo = $frames.filter(videoId);
    }

    /**
     * Следующий слайд в попапе
     */
    const toNextSlideInPopup = () => {
        if (slideIndex < $slides.length - 1) {
            slideIndex++;
            setSlidesCounter(slideIndex);
            $frames.hide();
            $currentVideo.next().show();
            $currentVideo = $currentVideo.next();
        }
    };

    /**
     * Предыдущий слайд в попапе
     */
    const toPrevSlideInPopup = () => {
        if (slideIndex > 0) {
            slideIndex--;
            setSlidesCounter(slideIndex);
            $frames.hide();
            $currentVideo.prev().show();
            $currentVideo = $currentVideo.prev();
        }
    };

    /**
     * Устанавливает блокировку на кнопку next/prev
     */
    const setDisabledButtonInPopup = function () {

        if ($slides.length === 1) {
            $nextButton.addClass('disabled');
            $prevButton.addClass('disabled');

            return;
        }

        switch (slideIndex) {
            case 0:
                $prevButton.addClass('disabled');
                $nextButton.removeClass('disabled');
                break;
            case $slides.length - 1:
                $nextButton.addClass('disabled');
                $prevButton.removeClass('disabled');
                break;
            default:
                $nextButton.removeClass('disabled');
                $prevButton.removeClass('disabled');
        }
    };

    /**
     * Изменяет состояния лоадера
     */

    const toggleLoader = (isLoading) => {
        const $popupContent = $popup.find('.js-popup-content');

        if (isLoading) {
            $popupContent.addClass('loading');
        } else {
            $popupContent.removeClass('loading');
        }
    };

    /**
     * Устанавливает нужный размер для iframe
     */
    const setSizeFrame = function () {
        let newStringSrc;
        let $frameHolder = $frames.eq(slideIndex);
        let $frame = $frameHolder.find('iframe');
        let originalFramesAttribute = {
            src: $frame.attr('src'),
            width: $frame.attr('width'),
            height: $frame.attr('height')
        }

        if (SVK.checkBreakpoint() === 'mobile') {
            $frame.attr('width', '100%');
            $frame.attr('height', '100%')
            newStringSrc = originalFramesAttribute.src.replace(/width="?\d+"?/i, 'width=288');
            newStringSrc = newStringSrc.replace(/height="?\d+"?/i, 'height=163');
            $frame.attr('src', newStringSrc);
        } else {
            $frame.attr('src', originalFramesAttribute.src);
            $frame.attr('width', originalFramesAttribute.width);
            $frame.attr('height', originalFramesAttribute.height)
        }
     };

    /**
     * Инициализация ивентов
     */
    const initEvents = () => {
        $self.on('click', '.js-gallery-item', function () {
            openPopup($(this).index());
            showVideo($(this).data('id'));
        });
        $popup.on('click', function (e) {
            let $target = $(e.target);
            if ($target.is($popup) || $target.closest('.js-popup-close').length) {
                $.magnificPopup.close();
                $('html').removeClass('fixed');
            } else if ($target.closest('.js-popup-prev').length) {
                toPrevSlideInPopup();
            } else if ($target.closest('.js-popup-next').length) {
                toNextSlideInPopup();
            }

            setDisabledButtonInPopup();
            setSizeFrame();
            toggleLoader(true);
        });

        $frames.find('iframe').on('load', function () {
            toggleLoader(false);
        });

        $(document).on('keydown', function (e) {
            if ($(document).find($popup).length) {
                switch (e.key) {
                    case 'Escape':
                        $.magnificPopup.close();
                        $('html').removeClass('fixed');
                        break;
                    case 'ArrowLeft':
                        toPrevSlideInPopup();
                        break;
                    case 'ArrowRight':
                        toNextSlideInPopup();
                        break;
                    case ' ':
                        toNextSlideInPopup();
                        break;
                }
            }

            setDisabledButtonInPopup();
            setSizeFrame();
            toggleLoader(true);
        });

        if (typeof $.fn.swipe !== 'undefined') {
            $popup.swipe({
                swipe: function (event, direction) {
                    switch (direction) {
                        case 'left':
                            toNextSlideInPopup();
                            break;
                        case 'right':
                            toPrevSlideInPopup();
                            break;
                    }

                    setDisabledButtonInPopup();
                    setSizeFrame();
                    toggleLoader(true);
                }
            })
        }
    };

    /**
     * Инициализация
     */
    const init = () => {
        initEvents();


        if ($slides.length === 1) {
            $popup.find('.js-popup-prev').hide();
            $popup.find('.js-popup-next').hide();
        } else {
            setDisabledButtonInPopup();
        }

    };

    init();

};
